import { render, staticRenderFns } from "./QuotaHistory.vue?vue&type=template&id=32500ea9&scoped=true"
import script from "./QuotaHistory.vue?vue&type=script&lang=js"
export * from "./QuotaHistory.vue?vue&type=script&lang=js"
import style0 from "./QuotaHistory.vue?vue&type=style&index=0&id=32500ea9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32500ea9",
  null
  
)

export default component.exports